import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { StackLayout } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';

// Post-login landing page for a non-impersonating caregiver: the caregiver
// home. The entire page body (the care-recipient switcher — recipient list,
// switch/impersonate CTAs, empty state) is server-driven by the Masonry node
// `core$caregiver$caregiverHome$root`. The `@leagueplatform/caregiver` package
// registers every custom renderer these nodes use on import. This page only
// owns the layout wrapper, document title, and page-view analytics.
export const CaregiverHomePage = () => {
  usePageViewAnalytics({ screen_name: 'Caregiver Home' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_CAREGIVER_HOME' }));

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="stretch"
      css={{
        marginX: 'auto',
        padding: '$none $two',
        maxWidth: CONTENT_MAX_WIDTH,
        '@mobile': {
          padding: '$none $one',
        },
      }}
    >
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_CAREGIVER_HOME} />
    </StackLayout>
  );
};
